import Colors from '@dynatrace/strato-design-tokens/colors';

export const CHART_OVERLAYS_BORDER_WIDTH = 1;

export const SELECTED_AREA_RADIUS = 4;

export const ZOOM_AREA_STYLES = {
  fill: Colors.Background.Field.Neutral.Accent,
  stroke: 'transparent',
  opacity: 0.1,
};

export const KNOB_HEIGHT = 40;
export const KNOB_WIDTH = 5;
